import { render, staticRenderFns } from "./NewsAndEvents.vue?vue&type=template&id=5639103c"
import script from "./NewsAndEvents.vue?vue&type=script&lang=js"
export * from "./NewsAndEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports